import { render, staticRenderFns } from "./OpenTextFile.vue?vue&type=template&id=48bec3df&scoped=true"
import script from "./OpenTextFile.vue?vue&type=script&lang=js"
export * from "./OpenTextFile.vue?vue&type=script&lang=js"
import style0 from "./OpenTextFile.vue?vue&type=style&index=0&id=48bec3df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bec3df",
  null
  
)

export default component.exports